export default function getResource(label, vars = []) {
    const resources = {
        nickname: 'Nickname',
        nicknameDescription: 'Your nickname will be displayed publicly on Sephora product reviews, product Questions & Answers, and Gallery.'
    };
    return resources[label];
}
